import React from 'react';
import { Route } from 'react-router-dom';
import BorrowingLayout from 'app/components/borrowing/shared/BorrowingLayout';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import InterlibraryLoansPageRoute from './InterlibraryLoansPageRoute';

const basePath = '/v2/interlibraryloans';

export default (
  <Route path={`${basePath}/:status?`}>
    <AuthenticatedRoute>
      <AccountRequiredRoute>
        <BorrowingLayout>
          <InterlibraryLoansPageRoute />
        </BorrowingLayout>
      </AccountRequiredRoute>
    </AuthenticatedRoute>
  </Route>
);
